import React from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { withRouter } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { logout } from "../../../actions/authentication/authentication";
import { Link } from "react-router-dom";

class MenuSuperAdmin extends React.Component {
  logout(e) {
    e.preventDefault();
    e.stopPropagation();

    // let that = this;

    function onLogoutSuccess() {
      // that.props.history.push('/');
      return window.location.replace("/");
    }

    // Call logout and redirect on success
    this.props.onLogout(onLogoutSuccess);
  }

  render() {
    return (
      <nav className="navbar navbar-expand-lg menu">
        <div
          id="menu"
          className="collapse navbar-collapse mb-3 mb-md-0 mt-2 pb-2"
        >
          <ul className="navbar-nav list-inline text-center align-items-center">
            <li className="nav-item list-inline-item align-middle">
              <Link
                to="/#"
                className="logo-item"
                onClick={(e) => this.logout(e)}
              >
                <img
                  className="logo-header"
                  alt="logo e4coll"
                  src="./images/svg/logo_e4BIZZ.svg"
                />
              </Link>
            </li>

            <li className="nav-item list-inline-item align-middle text-nowrap">
              <NavLink
                className="w-100 p-3"
                to="/home/company/"
                exact
                activeClassName="selected"
              >
                <FormattedMessage id="Menu.SuperAdmin.Company" />
              </NavLink>
            </li>

            <li className="nav-item list-inline-item align-middle text-nowrap">
              <NavLink
                className="w-100 p-3"
                to="/home/stats/"
                exact
                activeClassName="selected"
              >
                <FormattedMessage id="Stats" />
              </NavLink>
            </li>
            <button
              className="btn btn-danger ml-auto"
              onClick={(e) => this.logout(e)}
            >
              <FormattedMessage id="Logout" />
            </button>
          </ul>
        </div>
      </nav>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    lang: state.i18n.lang,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLogout: (successCallback) => dispatch(logout(successCallback)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MenuSuperAdmin),
);
